import { structure as structureSelector, query as querySelector } from '@Pages/QuickSearch/Components/QuickResults/QuickResultsSelectors';
import { resultsState } from '@Pages/Results/selectors';
import { connect } from 'react-redux';
import IntegratedFeedback from '@Components/IntegratedFeedback/IntegratedFeedback';

const mapStateToProps = (state) => {
  return {
    userSearchInput: {
      query: querySelector(state),
      structure: structureSelector(state),
    },
    resultState: resultsState(state)?.requestedParams,
  };
};

export default connect(mapStateToProps, null)(IntegratedFeedback);
